module.exports = "/assets/data/5530336095edacbeef4547fdc5faedfa-HU15.data.json";